import React from "react";
import 'tachyons';
import '../styles/App.css';

import Nav from "./Nav";
import Homepage from "./Homepage";
import About from "./About";
import Projects from "./Projects";
import Skills from "./Skills";
import Experience from "./Experience";
import ContactMe from "./ContactMe";

// config file
import config from "../../utils/config.json";

class App extends React.Component{
  render(){
    return(
      <div className="container">
        <Nav name={config.person.first_name}/>
        <section id="homepage">
          <Homepage person={config.person} links={config.links}/>
        </section>
        <section id="aboutpage">
          <About details={config.about}/>
        </section>
        <section id="experiencepage">
          <Experience workExperiences={config.workExperiences}/>
        </section>
        <section id="projectspage">
          <Projects projectList={config.projects} links={config.links}/>
        </section>
        <section id="skillspage">
          <Skills />
        </section>
        <section id="contactpage">
          <ContactMe contactMe={config.contactMe} links={config.links}/>
        </section>
      </div>
    )
  }
}

export default App;